const menuItems = document.querySelectorAll('.nav__item--mob');

if (menuItems) {
  menuItems.forEach(el => {
    el.addEventListener('click', (e) => {
      let sublink = e.target.closest('.nav__item--mob').querySelector('.nav__sublist--mob');
      sublink.classList.toggle('open');
      e.target.closest('.nav__item--mob').classList.toggle('open');
    });
  })
}